<template>
    <client-side-table
        idKey="contentNumber"
        ref="added-media-table"
        stripe
        :search="false"
        :hoverFlat="true"
        :columns="columns"
        :data="data"
        :paginate="false"
    >
        <template v-slot:Action="{ row }">
            <div class="flex">
                <vx-action-icon
                    icon="XIcon"
                    hover-color="danger"
                    tooltip="Remove Media"
                    @click.stop.prevent="removeMedia(row)"
                />
                <vx-action-icon
                    class="ml-4"
                    icon="EditIcon"
                    hover-color="success"
                    tooltip="Edit Media"
                    @click.stop.prevent="editMedia(row)"
                />
            </div>
        </template>
        <template v-slot:mediaType="{ row }">
            <div class="flex">
                {{ row.mediaType }}
            </div>
        </template>
        <template v-slot:Preview="{ row }">
            <audio
                v-if="row.audioFile"
                :src="row.audioFile.src"
                controls
                :title="row.audioFile.filename"
            ></audio>
        </template>
    </client-side-table>
</template>

<script>
import ClientSideTable from '@/components/custom/ClientSideTable'

export default {
    name: 'added-media-table',
    components: {
        ClientSideTable
    },
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    computed: {
        columns() {
            return [
                { title: 'Sort Order', value: 'sortOrder' },
                { title: 'Content Number', value: 'contentNumber' },
                { title: 'Description', value: 'description' },
                { title: 'Duration (mins)', value: 'durationMinutes' },
                { title: 'Author', value: (v) => v.author.firstName + ' ' + v.author.lastName },
                {
                    title: 'Media Type',
                    value: 'mediaType',
                    format: (mediaType) => (mediaType == 1 ? 'Audio' : 'Vimeo')
                },
                {
                    title: 'Preview'
                },
                {
                    title: 'Available From',
                    value: (v) =>
                        v.availableFrom
                            ? new Date(v.availableFrom).toLocaleDateString('en-AU')
                            : '-'
                },
                {
                    title: 'Available To',
                    value: (v) =>
                        v.availableTo ? new Date(v.availableTo).toLocaleDateString('en-AU') : '-'
                },
                { title: 'Action', value: '' }
            ]
        }
    },
    methods: {
        removeMedia(row) {
            this.$emit('removeMedia', row)
        },
        editMedia(row) {
            this.$emit('editMedia', row)
        }
    }
}
</script>

<style lang="scss" scoped></style>
